import { QueryClient } from '@tanstack/react-query';
import logger from '../utils/logger';

// Configure React Query with optimal defaults for admin dashboard
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 5 minutes before considering it stale
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Keep unused data in cache for 10 minutes (gcTime replaces cacheTime in v5)
      gcTime: 10 * 60 * 1000, // 10 minutes
      // Retry failed requests 2 times
      retry: 2,
      // Retry delay increases exponentially
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Refetch on window focus (good for admin dashboards)
      refetchOnWindowFocus: true,
      // Don't refetch on mount if data is fresh
      refetchOnMount: false,
      // Don't refetch on reconnect if data is fresh
      refetchOnReconnect: true,
    },
    mutations: {
      // Retry mutations once
      retry: 1,
      // Show error state for 5 seconds
      onError: (error) => {
        logger.error('Mutation error:', error);
      },
    },
  },
});

// Helper function to invalidate queries (useful after mutations)
export const invalidateQueries = (queryKey) => {
  queryClient.invalidateQueries({ queryKey });
};

// Helper function to refetch queries
export const refetchQueries = (queryKey) => {
  queryClient.refetchQueries({ queryKey });
};



